/** AUTO GENERATED FILE, DO NOT CHANGE MANUALLY */
/** SEE: api/ConstClassFactory */
export const DossierItemType = {
email: 'email',
invoice: 'invoice',
note: 'note',
}